export default __webpack_public_path__ + "static/media/icon-remove.70c075ce.svg";